import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import FAQ_DATA from '../faqData';

const FAQSection = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [openItems, setOpenItems] = useState(new Set(['0-0'])); // First item open by default

  const toggleItem = (categoryIndex, questionIndex) => {
    const itemId = `${categoryIndex}-${questionIndex}`;
    const newOpenItems = new Set(openItems);
    
    if (newOpenItems.has(itemId)) {
      newOpenItems.delete(itemId);
    } else {
      newOpenItems.add(itemId);
    }
    
    setOpenItems(newOpenItems);
  };

  const filteredFAQ = FAQ_DATA.map(category => ({
    ...category,
    questions: category.questions.filter(
      item =>
        item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.answer.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.questions.length > 0);

  const totalQuestions = FAQ_DATA.reduce((total, category) => total + category.questions.length, 0);
  const filteredCount = filteredFAQ.reduce((total, category) => total + category.questions.length, 0);

  return (
    <div className="bg-white rounded-2xl p-8 border border-black/10">
      <div className="mb-8">
        <h2 className="text-2xl sm:text-[26px] font-medium text-black mb-4" style={{ letterSpacing: '-0.005em' }}>
          Preguntas Frecuentes
        </h2>
        <p className="text-black/60 mb-6">
          Encuentra respuestas a las preguntas más comunes sobre nuestros servicios de consultoría de automatización e IA.
        </p>

        {/* Search */}
        <div className="relative">
          <Input
            type="search"
            placeholder="Buscar en preguntas frecuentes..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-12"
          />
          <Icon
            name="Search"
            size={20}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-black/30"
          />
        </div>

        {/* Results Counter */}
        {searchTerm && (
          <p className="text-sm text-black/50 mt-2">
            Mostrando {filteredCount} de {totalQuestions} preguntas
          </p>
        )}
      </div>

      {filteredFAQ.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Search" size={48} className="mx-auto text-black/20 mb-4" />
          <h3 className="text-xl font-semibold text-black mb-2">
            No se encontraron resultados
          </h3>
          <p className="text-black/60">
            Intenta con otros términos de búsqueda o{' '}
            <button
              onClick={() => setSearchTerm('')}
              className="text-[#7C3AED] font-medium hover:opacity-70 transition-opacity"
            >
              ver todas las preguntas
            </button>
          </p>
        </div>
      ) : (
        <div className="space-y-8">
          {filteredFAQ.map((category, categoryIndex) => (
            <div key={categoryIndex}>
              <h3 className="text-lg font-semibold text-black mb-4 flex items-center">
                <div className="w-2 h-2 bg-[#7C3AED] rounded-full mr-3" />
                {category.category}
              </h3>

              <div className="space-y-4">
                {category.questions.map((item, questionIndex) => {
                  const itemId = `${categoryIndex}-${questionIndex}`;
                  const isOpen = openItems.has(itemId);

                  return (
                    <div
                      key={questionIndex}
                      className="border border-black/10 rounded-lg overflow-hidden hover:border-[#7C3AED]/40 transition-colors"
                    >
                      <button
                        onClick={() => toggleItem(categoryIndex, questionIndex)}
                        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-black/[0.03] transition-colors"
                      >
                        <span className="font-medium text-black pr-4">
                          {item.question}
                        </span>
                        <Icon
                          name={isOpen ? "ChevronUp" : "ChevronDown"}
                          size={20}
                          className={`text-black/40 transition-transform duration-200 ${
                            isOpen ? 'transform rotate-180' : ''
                          }`}
                        />
                      </button>

                      {/* siempre en el DOM (hidden en vez de no renderizar) para que
                          buscadores y crawlers de IA lean todas las respuestas */}
                      <div className="px-6 pb-4" hidden={!isOpen}>
                        <div className="text-black/60 leading-relaxed whitespace-pre-line">
                          {item.answer}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Contact CTA -- incluye la urgencia que antes vivía en un banner aparte */}
      <div className="mt-8 pt-8 border-t border-black/10 text-center">
        <div className="w-12 h-12 rounded-full bg-black/5 border border-black/10 flex items-center justify-center mx-auto mb-4">
          <Icon name="Headset" size={22} className="text-[#7C3AED]" />
        </div>
        <h4 className="text-lg font-semibold text-black mb-2">
          ¿No encontraste lo que buscabas?
        </h4>
        <p className="text-black/60 mb-6 max-w-md mx-auto">
          Nuestro equipo está listo para responder cualquier pregunta específica sobre tu proyecto —
          incluso fuera de horario, para emergencias técnicas críticas.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => window.open('https://wa.me/+573228571202', '_blank')}
            className="inline-flex items-center justify-center gap-2 bg-black text-white text-[14px] font-medium px-6 py-3 rounded-full hover:opacity-80 transition-opacity"
          >
            <Icon name="MessageCircle" size={18} />
            Preguntar por WhatsApp
          </button>
          <button
            onClick={() => window.open('mailto:contacto@orbiax.co')}
            className="inline-flex items-center justify-center gap-2 text-black text-[14px] font-medium border border-black/20 px-6 py-3 rounded-full hover:bg-black hover:text-white transition-colors duration-200"
          >
            <Icon name="Mail" size={18} />
            Enviar Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;